import { render } from "./LinkBubble.vue?vue&type=template&id=1459a086"
import script from "./LinkBubble.vue?vue&type=script&lang=js"
export * from "./LinkBubble.vue?vue&type=script&lang=js"

import "./LinkBubble.vue?vue&type=style&index=0&id=1459a086&scope=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__